import React, { Component } from 'react'
import styled from 'styled-components'

const HeaderStyles = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
`

const Logo = styled.h1`
  font-size: 2.5em;
  font-weight: 300;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`

class Header extends Component {
  render () {
    return (
      <HeaderStyles>
        <Logo>Pipeline TV</Logo>
      </HeaderStyles>
    )
  }
}

export default Header
